import { FC } from 'react'
import Swal from 'sweetalert2'
import {
  IconPaths,
  ModalSize,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { deleteExameCliente, getExameClienteById } from '../../core/_request'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { ExameClienteModal } from '../../components/modal/ExameClienteModal'
import { ExameAsoView } from '../../core/_models'

type Props = {
  exame: ExameAsoView
}

export const ExameActionsCell: FC<Props> = ({ exame }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const nome = exame.exame || 'Exame'

  const openEditModal = () => {
    showModal({
      title: 'Exame',
      content: <ExameClienteModal />,
      size: ModalSize.Medium,
      fetchers: {
        exame: () => getExameClienteById(exame.id),
      },
    })
  }

  // Excluir é destrutivo: confirmação com a consequência.
  const askDelete = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Excluir exame?',
      text: `${nome} será excluído. Essa ação não pode ser desfeita.`,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmed) return

    try {
      showAlertLoading()
      await deleteExameCliente(exame.id)
      Swal.close()
      showToast({ variant: 'success', title: `${nome} foi excluído.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: 'Alterar', onClick: openEditModal, icon: IconPaths.Pen }}
      items={[{ label: 'Excluir', onClick: askDelete, danger: true }]}
    />
  )
}
